import Reveal from "@/components/Reveal";

const SectionHeading = ({ kicker, title, description, dark = false, className = "" }) => (
    <div className={className}>
        <Reveal>
            <div className="flex items-center gap-3">
                <span className={`h-px w-10 ${dark ? "bg-emerald-400" : "bg-emerald-500"}`} />
                <span className={`font-mono text-[11px] font-bold uppercase tracking-[0.25em] ${dark ? "text-emerald-400" : "text-emerald-600"}`}>
                    {kicker}
                </span>
            </div>
        </Reveal>
        <Reveal delay={0.08}>
            <h2 className={`mt-5 font-display text-3xl font-extrabold tracking-tight sm:text-4xl lg:text-[2.75rem] lg:leading-[1.08] ${dark ? "text-white" : "text-slate-900"}`}>
                {title}
            </h2>
        </Reveal>
        {description && (
            <Reveal delay={0.16}>
                <p className={`mt-5 max-w-2xl text-base leading-relaxed sm:text-lg ${dark ? "text-slate-300" : "text-slate-600"}`}>
                    {description}
                </p>
            </Reveal>
        )}
    </div>
);

export default SectionHeading;
